/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateTreatmentPlanResponseDto
 */
export interface GenerateTreatmentPlanResponseDto {
    /**
     * Status of the treatment plan generation
     * @type {string}
     * @memberof GenerateTreatmentPlanResponseDto
     */
    status: string;
    /**
     * Treatment plan ID
     * @type {string}
     * @memberof GenerateTreatmentPlanResponseDto
     */
    treatmentPlanId: string;
}

/**
 * Check if a given object implements the GenerateTreatmentPlanResponseDto interface.
 */
export function instanceOfGenerateTreatmentPlanResponseDto(value: object): value is GenerateTreatmentPlanResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('treatmentPlanId' in value) || value['treatmentPlanId'] === undefined) return false;
    return true;
}

export function GenerateTreatmentPlanResponseDtoFromJSON(json: any): GenerateTreatmentPlanResponseDto {
    return GenerateTreatmentPlanResponseDtoFromJSONTyped(json, false);
}

export function GenerateTreatmentPlanResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateTreatmentPlanResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'treatmentPlanId': json['treatment_plan_id'],
    };
}

export function GenerateTreatmentPlanResponseDtoToJSON(json: any): GenerateTreatmentPlanResponseDto {
    return GenerateTreatmentPlanResponseDtoToJSONTyped(json, false);
}

export function GenerateTreatmentPlanResponseDtoToJSONTyped(value?: GenerateTreatmentPlanResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'treatment_plan_id': value['treatmentPlanId'],
    };
}

